function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF0000",
  d: "M0,465.1v-44.3c0-36.7,29.7-66.4,66.4-66.4H1063V221.5c0-59.1,71.7-88.7,113.4-47l221.5,221.5 c25.9,25.9,25.9,68,0,94l-221.5,221.5c-41.6,41.6-113.4,12.4-113.4-47V531.5H66.4C29.7,531.5,0,501.8,0,465.1z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#062AFF",
  d: "M1350.9,885.8H354.3V753c0-59-71.6-88.8-113.4-47L19.5,927.4c-25.9,25.9-25.9,68,0,94l221.5,221.5 c41.6,41.6,113.4,12.4,113.4-47V1063h996.6c36.7,0,66.4-29.7,66.4-66.4v-44.3C1417.3,915.6,1387.6,885.8,1350.9,885.8z"
});

var SvgExchange = function SvgExchange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    focusable: "false",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1417.3 1417.3",
    enableBackground: "new 0 0 1417.3 1417.3",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExchange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exchange.894c76a9.svg";
export { ForwardRef as ReactComponent };